import { createCommentVNode as e, createElementBlock as t, createTextVNode as n, defineComponent as r, normalizeClass as i, openBlock as a, renderSlot as o } from "vue";
//#region src/schema/SchemaPropertyDetail.vue?vue&type=script&setup=true&lang.ts
var s = {
	key: 0,
	class: "property-detail-prefix"
}, c = {
	key: 1,
	class: "property-detail-value"
}, l = {
	key: 2,
	class: "property-detail-value"
}, u = /*@__PURE__*/ r({
	__name: "SchemaPropertyDetail",
	props: {
		truncate: { type: Boolean },
		code: { type: Boolean }
	},
	setup(r) {
		return (u, d) => (a(), t("span", { class: i(["property-detail", { "property-detail-truncate": r.truncate }]) }, [u.$slots.prefix ? (a(), t("div", s, [o(u.$slots, "prefix", {}, void 0, !0), d[0] ||= n("\xA0 ", -1)])) : e("", !0), r.code ? (a(), t("code", c, [o(u.$slots, "default", {}, void 0, !0)])) : (a(), t("span", l, [o(u.$slots, "default", {}, void 0, !0)]))], 2));
	}
});
//#endregion
export { u as default };

//# sourceMappingURL=SchemaPropertyDetail.vue_vue_type_script_setup_true_lang.js.map